<template>
  <button
    type="button"
    :class="$style.btn"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ActionButton',
  emits: ['click']
};
</script>

<style module>
.btn {
  @mixin reset-button-styles;
  height: 20px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #050505;
  outline: none;
  cursor: pointer;
  opacity: 0.5;
  &:not(:disabled):hover {
    color: $black;
    opacity: 1;
  }
  &:disabled {
    color: #bfbfbf;
    cursor: default;
  }
}
</style>

<i18n lang="json">{}</i18n>
